export { default } from './AboutHeroSection';
